var map = {
	"./Practice Required.svg": 169,
	"./Scope for Improvement.svg": 170,
	"./Well done.svg": 171,
	"./etq-cube.svg": 54,
	"./ht-1.svg": 172,
	"./ht-2.svg": 173,
	"./ht-3.svg": 174,
	"./ht-4.svg": 175,
	"./ht-5.svg": 176,
	"./ht-rt-it.svg": 177,
	"./it-1.svg": 178,
	"./it-2.svg": 179,
	"./it-3.svg": 180,
	"./it-4.svg": 181,
	"./it-5.svg": 182,
	"./it-ht.svg": 183,
	"./rt-1.svg": 184,
	"./rt-2.svg": 185,
	"./rt-3.svg": 186,
	"./rt-4.svg": 187,
	"./rt-5.svg": 188,
	"./rt-ht.svg": 189,
	"./rt-it.svg": 190
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45;